(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Stepper", [], factory);
	else if(typeof exports === 'object')
		exports["Stepper"] = factory();
	else
		root["Stepper"] = factory();
})(this, function() {
return 